import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { useGetInvoices } from '@/services/hooks';
import React, { useEffect, useState } from 'react';
import useHomeStore from '@/store/home';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import DesktopPageLoader from '@/components/desktop/pageLoader';

const DesktopInvoice = () => {
  const [searchParams] = useSearchParams();
  const pgc = searchParams.get('pgc');
  const { setExpiredAt, setInvoice, setRemainInvoice } = useHomeStore();
  const { data, error } = useGetInvoices();
  const [manualLoading, setManualLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  useEffect(() => {
    if (data?.invoiceStatusId === 10 && data?.ipgurl) {
      window.location.assign(data?.ipgurl);
    } else if (data?.invoiceStatusId === 40 || data?.invoiceStatusId === 20) {
      navigate('/receipt');
      setManualLoading(false);
    } else if (data?.invoiceExpireTime) {
      setManualLoading(false);
      setExpiredAt(data?.invoiceExpireTime);
      localStorage.setItem('expiredAt', data?.invoiceExpireTime?.toString());
      setInvoice(data?.amount);
      setRemainInvoice(data?.amount);
    }
  }, [data]);

  useEffect(() => {
    const theError = error as AxiosError;
    if (theError?.response?.status === 401) {
      window.localStorage.clear();
      navigate(`/login?pgc=${pgc}`);
    }
  }, [error]);
  if (manualLoading) return <DesktopPageLoader />;
  if (!data) return null;
  return (
    <Container className='mt-3 w-full flex-col dark:border-grayDark-750'>
      <Container
        center
        className='w-full justify-between gap-2 p-4 pl-[25px] md:justify-start'
      >
        <Text className='text-lg text-grayLight-1000 dark:text-grayLight-0' medium>
          {localization.merchant}
        </Text>
      </Container>
      <Container className='flex w-full items-center rounded-2xl border border-gray-100 bg-grayLight-50 p-6  dark:border-grayDark-700 dark:bg-grayDark-750'>
        <Container center className='ml-3 h-12 w-12 rounded-[7px]'>
          <img src={data?.merchantLogo} className='rounded-full' alt='' />
        </Container>
        <Container className='flex flex-col'>
          <Text className='text-md text-grayLight-1000 dark:text-grayLight-0 '>
            {data.merchantBrandName}
          </Text>
        </Container>
      </Container>
    </Container>
  );
};
export default DesktopInvoice;
